import { Grid, Divider } from "@mui/material"

const FullWidthDivider = () => {
    return <Grid item ><Divider /></Grid>
}

export default FullWidthDivider
